import styled from 'styled-components';
import { Button } from 'reactstrap';
export default styled(Button).withConfig({
  displayName: "HiddenButton",
  componentId: "sc-1ffna8j-0"
})(["display:none !important;"]);